export function hashPrefixed(hex?: string): string {
  if (!hex) return ''
  return hex[0] === '#' ? hex : '#' + hex
}

export const availabilitySortOrder = ['core', 'limited edition']

/** Sort an array of `Colors` based on their availability. */
export function sortColorsByAvailability<T extends { availability: string }>(
  colors: T[],
  sortOrder: string[] = availabilitySortOrder
) {
  // Sort colors based on `color.availability` and the sort order defined above (`availabilitySortOrder`).
  // If `color.availability` does not exist in the sort order, make sure it's displayed after
  // all colors that do have an identified availability (i.e. `core`, `limited edition`).
  return colors.sort((a, b) => {
    const aIndex = sortOrder.indexOf(a.availability)
    const bIndex = sortOrder.indexOf(b.availability)

    // Items not found in the sort order get a large index to appear last
    const aSortValue = aIndex === -1 ? Infinity : aIndex
    const bSortValue = bIndex === -1 ? Infinity : bIndex

    return aSortValue - bSortValue
  })
}
